/* Newsletter relay — posts sign-ups to the /apps/notify proxy (partners.mpgames.io),
   matching the mpgames storefront. Replaces Shopify's native customer form and the
   removed Klaviyo onsite embed.

   Any form with `data-nl-relay` is handled here. Expected structure:
     <form data-nl-relay data-nl-name="{{ customer.name }}">
       <div data-nl-fields> ...<input type="email" name="email" required>... </div>
       <p data-nl-ok hidden>Success message</p>
       <p data-nl-err hidden></p>
     </form>

   POST /apps/notify  { "type": "newsletter", "email": "...", "name": "...|null" }
*/
(function () {
  "use strict";

  var ENDPOINT = "/apps/notify";

  function submit(form) {
    var emailInput = form.querySelector('input[type="email"]');
    var email = emailInput ? (emailInput.value || "").trim() : "";
    var fields = form.querySelector("[data-nl-fields]");
    var okEl = form.querySelector("[data-nl-ok]");
    var errEl = form.querySelector("[data-nl-err]");
    var button = form.querySelector('button[type="submit"], button:not([type])');
    var consent = form.querySelector('input[type="checkbox"]');

    function showError(message) {
      if (!errEl) { return; }
      errEl.textContent = message;
      errEl.hidden = false;
    }

    if (errEl) { errEl.hidden = true; errEl.textContent = ""; }

    if (!email || (emailInput && !emailInput.checkValidity())) {
      showError("Please enter a valid email address.");
      if (emailInput) { emailInput.focus(); }
      return;
    }
    if (consent && !consent.checked) {
      showError("Please accept the terms to subscribe.");
      return;
    }

    var originalLabel;
    if (button) { originalLabel = button.innerHTML; button.disabled = true; }

    var name = form.getAttribute("data-nl-name");
    if (!name) { name = undefined; }

    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ type: "newsletter", email: email, name: name })
    })
      .then(function (response) {
        if (!response.ok) { throw new Error("newsletter relay returned " + response.status); }
        return response.json().catch(function () { return {}; });
      })
      .then(function () {
        if (fields) { fields.hidden = true; }
        if (okEl) { okEl.hidden = false; }
      })
      .catch(function () {
        if (button) { button.disabled = false; button.innerHTML = originalLabel; }
        showError("Sorry, something went wrong. Please try again.");
      });
  }

  document.addEventListener("submit", function (event) {
    var form = event.target.closest ? event.target.closest("form[data-nl-relay]") : undefined;
    if (!form) { return; }
    event.preventDefault();
    submit(form);
  });
})();
